<template>
  <div
    v-if="item?.salesPackageSize"
    :class="{
      'product-package-size-fi': true,
      'product-package-size-fi--align-right': alignRight,
    }"
  >
    {{ noBrackets ? '' : '(' }}
    {{ item.salesPackageSize }}
    {{ item.salesPackageUnit && getSellingUnit(item.salesPackageUnit) }} /
    {{ getSellingPackage(item.salesPackageUnit) }}
    {{ noBrackets ? '' : ')' }}
  </div>
</template>

<script setup lang="ts">
import { useSellingUnits } from 'composables/sellingUnit';

import type { HybrisFischerBestPrice } from '@/generated/graphql';

defineOptions({
  name: 'ProductPackageSizeFi',
});

defineProps<{
  item?: HybrisFischerBestPrice | null;
  alignRight?: boolean;
  noBrackets?: boolean;
}>();

const { getSellingUnit, getSellingPackage } = useSellingUnits();
</script>

<style scoped lang="scss">
@import './product-package-size-fi';
</style>
